module.exports = {"player_position":"Player position","enemy_position":"Enemy position"};